/**
 * @generated SignedSource<<3aee236412786fbf3b1943c6f55623b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoLinkedContent_todo$data = {
  readonly descriptionFiles: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"LinkedContentInput_files">;
  }>;
  readonly descriptionImages: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"LinkedContentInput_images">;
  }>;
  readonly id: string;
  readonly " $fragmentType": "WorkspaceTodoLinkedContent_todo";
};
export type WorkspaceTodoLinkedContent_todo$key = {
  readonly " $data"?: WorkspaceTodoLinkedContent_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoLinkedContent_todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoLinkedContent_todo",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkedContentInput_images"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "descriptionFiles",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkedContentInput_files"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TodoWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "e99448dc5bfc937444c6c439629d29a2";

export default node;
